import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { newsConverter } from '@pc-converter';
import { convertDateToTsSeconds, getFetchEndDateForModels } from '@pc-helpers';
import { EnvironmentService, StoreService } from '@pc-services';
import { PcNews, PcNewsFirebase, PcTsSeconds, PC_COLLECTIONS } from '@pc-types';
import { ModelExtension } from './model.extension';

@Injectable({
  providedIn: 'root',
})
export class NewsService extends ModelExtension<PcNews, PcNewsFirebase> {
  protected referenceMainCollection = PC_COLLECTIONS.NEWS;
  protected referenceShopCollection = PC_COLLECTIONS.SHOP_NEWS;

  constructor(
    protected angularFirestore: AngularFirestore,
    protected store: StoreService,
    protected envService: EnvironmentService
  ) {
    super({
      angularFirestore,
      store,
      modelConverter: newsConverter,
      envService,
    });
  }

  public fetchAll(): void {
    this.fetchItems().subscribe((news) => {
      this.store.setNews(news);
    });
  }

  public fetchForFeed(): void {
    this.fetchItemsForFeed().subscribe((items) => {
      this.store.setFeedNews(items);
    });
  }

  public getEndDateForFetch(): PcTsSeconds {
    return convertDateToTsSeconds(getFetchEndDateForModels());
  }

  public getEndDateForFetchFeed(): PcTsSeconds {
    return convertDateToTsSeconds(new Date());
  }
}
